export default {
  setAppUpdateInfo(payload) {
    this.appUpdateInfo = payload;
  }, // setAppUpdateInfo()
};
